import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
import helper from "./userFacade";
const qs = require("qs");
export default {
  login(message) {
    return API.peakAPI
      .post("/api/Authentication/Login", message)
      .then((res) => {
        return {
          resCode: res.data.responseCode,
          merchantlist: res.data.logIn.merchantList,
          userModel: res.data.logIn.user,
        };
      })
      .catch((err) => err);
  },
  DoGetAccessToken(userName, password, userType = 0, source = Enums.ActivityLogSource.None) {
    const data = qs.stringify({
      grant_type: "password",
      client_id: "account",
      client_secret: "accountSecret",
      scope: "account.api.full offline_access openid",
      username: userName,
      password: password,
      user_type: userType,
      token: "",
      source: source,
    });
    return API.peakAuthenticationAPI
      .post("/connect/token", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoGetNewAccessTokenByRefreshToken() {
    const data = qs.stringify({
      grant_type: "refresh_token",
      client_id: "account",
      client_secret: "accountSecret",
      refresh_token: userInfo.GetRefreshToken(),
    });

    return API.peakAuthenticationAPI
      .post("/connect/token", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoGetRefreshTokenExpiration() {
    let refreshToken = userInfo.GetRefreshToken();
    if (refreshToken) {
      refreshToken = JSON.stringify(refreshToken);
    }
    return API.peakAuthenticationAPI
      .post("/token/GetRefreshTokenExpiration", refreshToken, {
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoGetUserInfoByUserId() {
    const headers = {
      Authorization: `Bearer ${userInfo.GetAccessToken()}`,
    };
    const params = {};
    return API.peakRealTimeAPIForUser.get("/api/User/GetUserInfoByUserId", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetRecommendForUser() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI.post("/api/Merchant/GetRecommend", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoRefreshMerchantList() {
    return API.peakAuthenticationAPI
      .post("/connect/userinfo", "", {
        headers: {
          Authorization: `Bearer ${userInfo.GetAccessToken()}`,
        },
      })
      .then((res) => {
        return res;
      });
  },
  DoSetForgotPwd(userName) {
    let input = {
      userName: userName,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/User/SetForgotPwd", input)
      .then((res) => {
        return {
          responseCode: res.data.responseCode,
        };
      })
      .catch((err) => err);
  },
  DoGetForgotPwd(_input) {
    let input = {
      forgotPwdId: _input.forgotPwdId,
      forgotPwdCode: _input.forgotPwdCode,
    };
    return API.peakRealTimeAPI
      .post("/api/User/GetForgotPwd", input)
      .then((res) => {
        return {
          responseCode: res.data.responseCode,
          forgotPwd: helper.ConvertToForgotPwd(res.data.forgotPwd),
        };
      })
      .catch((err) => err);
  },
  DoResetPwd(_input) {
    let input = {
      forgotPwdId: _input.forgotPwdId,
      forgotPwdCode: _input.forgotPwdCode,
      password: _input.password,
    };
    return API.peakRealTimeAPI
      .post("/api/User/ResetPwd", input)
      .then((res) => {
        return {
          responseCode: res.data.responseCode,
        };
      })
      .catch((err) => err);
  },
  DoGetUserDetailForDisplay(userIdList) {
    return API.peakAPI
      .post(
        "/api/User/GetUserDetailListForDisplay",
        {
          merchantId: userInfo.MerchantId(),
          userIdList: userIdList,
        },
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoGetAllUserDetailListForDisplayByMerchantId() {
    return API.peakAPI
      .post(
        "/api/User/GetAllUserDetailListForDisplayByMerchantId",
        {
          merchantId: userInfo.MerchantId(),
        },
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoRegister(_input) {
    let input = {
      userProfileModel: _input,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/User/Register", input)
      .then((res) => {
        return {
          res: res.data,
        };
      })
      .catch((err) => err);
  },
  DoRevokeRefreshToken() {
    let refreshToken = userInfo.GetRefreshToken();
    if (refreshToken) {
      const qs = require("qs");
      const data = qs.stringify({
        client_id: "account",
        client_secret: "accountSecret",
        token: userInfo.GetRefreshToken(),
        token_type_hint: "refresh_token",
      });
      return API.peakAuthenticationAPI
        .post("/connect/revocation", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => err.response);
    }
  },
  DoRevokeAccessToken() {
    let accessToken = userInfo.GetAccessToken();
    if (accessToken) {
      const qs = require("qs");
      const data = qs.stringify({
        client_id: "account",
        client_secret: "accountSecret",
        token: userInfo.GetAccessToken(),
        token_type_hint: "access_token",
      });
      return API.peakAuthenticationAPI
        .post("/connect/revocation", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => err.response);
    }
  },
  DoRevokeToken(idToken, userId) {
    const qs = require("qs");
    const data = qs.stringify({});
    return API.peakAuthenticationAPI
      .get("/connect/endsession?id_token_hint=" + idToken + "&eui=" + userId, data)
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoAddNewUser(userRoleDetail) {
    let input = {
      merchantId: userInfo.MerchantId(),
      userRoleDetail: userRoleDetail,
      invitationType: Enums.InvitationType.InviteUserToMerchant,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI.post("/api/User/AddNewUser", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoRemoveUser(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      fromMerchantId: _input.fromMerchantId,
      removeUserId: _input.userId,
    };
    return API.peakRealTimeAPI.post("/api/User/RemoveUser", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateUserProfile(userTemplate) {
    let input = {
      merchantId: userInfo.MerchantId(),
      userTemplate: userTemplate,
    };

    return API.peakRealTimeAPI.post("/api/User/UpdateUserProfile", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoChangePassword(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      password: _input.password,
      newPassword: _input.newPassword,
    };

    return API.peakRealTimeAPI.post("/api/User/ChangePassword", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateReferFriendStatusCaseCreateMerchant(input) {
    let _input = {
      merchantId: input.merchantId,
    };
    return API.peakRealTimeAPI
      .post("/api/User/DoUpdateReferFriendStatusCaseCreateMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoAcceptInvitation(input) {
    let _input = {
      invitationId: input.invitationId,
      invitationCode: input.invitationCode,
    };
    return API.peakRealTimeAPI.post("/api/User/AcceptInvitation", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoInsertUserProfileConsent(input) {
    let _input = {
      userId: input.userId,
      isConsentTerm: input.isConsentTerm,
    };
    return API.peakRealTimeAPI
      .post("/api/User/InsertUserProfileConsent", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetUserProfileConsent(userId) {
    let _input = {
      userId: userId,
    };
    return API.peakRealTimeAPI
      .post("/api/User/GetUserProfileConsent", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGet2ndLogin() {
    return API.peakAPI.post("/api/User/Get2ndLogin", {}, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoSet2ndLogin() {
    return API.peakAPI.post("/api/User/Set2ndLogin", {}, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetUserInAppPEAK(input) {
    let _input = {
      merchantId: input.merchantId,
      userId: input.userId,
      inAppSuggestionTypes: input.inAppSuggestionTypes,
    };
    return API.peakRealTimeAPI.post("/api/User/GetUserInAppPEAK", _input, userInfo.SetHeaderService()).then((res) => {
      return res.data;
    });
  },
  DoUpdateUserInAppPEAK(input) {
    let dateTimeNow = new Date();
    let _input = {
      merchantId: input.merchantId,
      userId: input.userId,
      inAppSuggestionData: {
        merchantId: input.merchantId,
        userId: input.userId,
        inAppType: input.inAppType,
        inAppValue: true,
        createdDateTime: dateTimeNow,
        updatedDateTime: dateTimeNow,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/User/UpdateUserInAppPEAK", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res.data;
      });
  },
  DoSendVideoFeedback(input) {
    return API.peakAPI
      .post("/api/User/UserFeedbackVideo", input, userInfo.SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err) => userInfo.CatchAPIService(err.response));
  },
  DoGetVideoFeedback(input) {
    return API.peakAPI
      .post("/api/User/GetUserFeedbackVideo", input, userInfo.SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err) => userInfo.CatchAPIService(err.response));
  },
  DoIntrospectAccessToken() {
    const data = qs.stringify({
      client_secret: "account.api.secret",
      client_id: "account.api",
      token: userInfo.GetAccessToken(),
    });
    return API.peakAuthenticationAPI
      .post("/connect/introspect", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoValidateUsername(username) {
    let _input = {
      username: username,
    };
    return API.peakRealTimeAPI.post("/api/User/ValidateUsername", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
};
